import React from "react";
import { Link } from "polyrouter";
import { useTranslation } from "utilities/i18n";

export const PolyPlusSetupOverview: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Link className="setup-link card p-2 mb-15" nest to="/activate">
        <h4 className="title-capitalized">{t("LICENSE_ACTIVATION_TITLE")}</h4>
        <p className="mv-5">{t("LICENSE_ACTIVATION_DESCRIPTION")}</p>
      </Link>
      <Link className="setup-link card p-2" nest to="/assign">
        <h4 className="title-capitalized">{t("POLY_PLUS_ASSIGN_TITLE")}</h4>
        <p className="mv-5">{t("POLY_PLUS_ASSIGN_DESCRIPTION")}</p>
      </Link>
    </>
  );
};
